// extracted by mini-css-extract-plugin
export var explainable = "_jr-a";
export var printerCard = "_jr-1";
export var printerCardConfigured = "_jr-2";
export var printerCardError = "_jr-3";
export var printerCardsContainer = "_jr-0";
export var printerIcon = "_jr-8";
export var printerIconConfigured = "_jr-5";
export var printerIconContainer = "_jr-4";
export var printerIconError = "_jr-6";
export var printerIconUnconfigured = "_jr-7";
export var workstationsTableCard = "_jr-9";